import { Button } from 'antd';

import { useTranslation } from '@/i18n/client';
import { EVENT } from '@/utils/event';

import MindverseModal, { SizeType } from '../modal';
import styles from './index.less';

interface CROMIprops {
  open: boolean;
  handleClose: () => void;
  title?: string;
}

function CreditRunOutModal(props: CROMIprops): JSX.Element {
  const { t } = useTranslation();
  const { open, handleClose, title = t('creditRunOutModal.title') } = props;

  return (
    <MindverseModal
      destroyOnClose
      footer={null}
      okButtonProps={{
        disabled: false
      }}
      onCancel={handleClose}
      open={open}
      size={SizeType.normal}
      title={title}
    >
      <div className={styles.modalContainer}>
        <div className={styles.content}>{t('creditRunOutModal.content')}</div>

        <div className={styles.buttonContainer}>
          <Button
            className={styles.naviBtn}
            onClick={() => {
              handleClose();
              dispatchEvent(new Event(EVENT.UNFOLD_SUBSCRIPTION));
            }}
            type="primary"
          >
            {t('creditRunOutModal.button')}
          </Button>
        </div>
      </div>
    </MindverseModal>
  );
}

export default CreditRunOutModal;
